'use client';

const SERVER_ACTION_RELOAD_KEY = '__skew_sa';
const SERVER_ACTION_RELOAD_INTERVAL = 5 * 60 * 1000;

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error ?? '');
}

export function isServerActionVersionSkew(error: unknown): boolean {
  const message = getErrorMessage(error);
  return (
    message.includes('Failed to find Server Action') ||
    (message.includes('Server Action') &&
      (message.includes('older or newer deployment') ||
        message.includes('not found')))
  );
}

export function reloadOnceForServerActionVersionSkew(error: unknown): boolean {
  if (!isServerActionVersionSkew(error)) return false;
  if (typeof window === 'undefined') return true;

  try {
    const lastReload = Number(
      window.sessionStorage.getItem(SERVER_ACTION_RELOAD_KEY) || 0,
    );
    if (lastReload && Date.now() - lastReload < SERVER_ACTION_RELOAD_INTERVAL) {
      return true;
    }
    window.sessionStorage.setItem(SERVER_ACTION_RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage can fail in restricted browser modes; still try to recover.
  }

  window.setTimeout(() => {
    window.location.reload();
  }, 0);
  return true;
}
